import {
  ARM_PRODUCT_TYPE,
  DC_PRODUCT_TYPE,
  NAS_PRODUCT_TYPE,
  OEC_PRODUCT_TYPE,
  OEC_TURBO_PRODUCT_TYPE,
  OES_PLUS_PRODUCT_TYPE,
  OES_PRODUCT_TYPE,
  PNWX_PRODUCT_TYPE,
  X86_PRODUCT_TYPE,
  PC_PAL_PRODUCT_TYPE,
  OEA_PRODUCT_TYPE,
  XLPC_PRODUCT_TYPE,
  OEA_LITE_PRODUCT_TYPE,
  KOOL_PRODUCT_TYPE,
} from '.';

export const DEVICE_STRATEGY_CONFIG = {
  [ARM_PRODUCT_TYPE]: {
    title: 'ARM推荐配置及说明',
    tableData: {
      header: ['运营商', '上行带宽', '推荐设备数', '硬盘推荐'],
      body: [
        [
          '{"content":"移动"}',
          '{"content":"20Mbps"}',
          '{"content":"1台"}',
          '{"content":"240G优质SSD"}',
        ],
        [
          '{"content":"移动"}',
          '{"content":"30Mbps"}',
          '{"content":"1台"}',
          '{"content":"480G优质SSD"}',
        ],
        [
          '{"content":"移动"}',
          '{"content":"50Mbps"}',
          '{"content":"2台"}',
          '{"content":"240G优质SSD"}',
        ],
        [
          '{"content":"移动"}',
          '{"content":"100Mbps"}',
          '{"content":"4台"}',
          '{"content":"240G优质SSD"}',
        ],
        [
          '{"content":"联通/电信"}',
          '{"content":"20Mbps"}',
          '{"content":"1台"}',
          '{"content":"240G优质SSD"}',
        ],
        [
          '{"content":"联通/电信"}',
          '{"content":"30Mbps"}',
          '{"content":"1台"}',
          '{"content":"480G优质SSD"}',
        ],
        [
          '{"content":"联通/电信"}',
          '{"content":"50Mbps"}',
          '{"content":"3台"}',
          '{"content":"240G优质SSD"}',
        ],
        [
          '{"content":"联通/电信"}',
          '{"content":"100Mbps"}',
          '{"content":"6台"}',
          '{"content":"240G优质SSD"}',
        ],
      ],
    },
    instructions: [
      {
        title: '适用设备类型',
        content: '现金版盒子、网心盒子、玩客云现金版、FX等arm架构设备；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型。拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；',
      },
      {
        title: '',
        content:
          '设备非拨号环境，推荐路由器设置DMZ并开启UPNP，设置DMZ时请配置MAC地址不以C0开头的设备IP；',
      },
      {
        title: '',
        content: '卓越型公网设备，推荐上行带宽≥30Mbps及480G以上SSD；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content:
          '请关注APP收益指标“丢包率”和“时延”，丢包率不超过5%，网络延迟不超过50ms，请关注带宽是否已达到瓶颈，并确认是否存在多层路由；',
      },
      { title: '', content: '硬盘格式性能排名依次为：裸盘＞EXT4，非裸盘可联系官方客服处理；' },
      {
        title: '',
        content:
          '设备激活上线后有5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定；',
      },
    ],
  },
  [X86_PRODUCT_TYPE]: {
    title: 'x86推荐配置及说明',
    tableData: {
      header: ['上行带宽', 'CPU', '内存', '硬盘'],
      body: [
        [
          '{"content":"100Mpbs"}',
          '{"content":"线程≥4，主频≥2G"}',
          '{"content":"≥4G"}',
          '{"content":"300-800G优质SSD"}',
        ],
        [
          '{"content":"500Mpbs"}',
          '{"content":"线程≥8，主频≥2G"}',
          '{"content":"≥8G"}',
          '{"content":"1-3T优质SSD"}',
        ],
        [
          '{"content":"1Gpbs"}',
          '{"content":"线程≥20，主频≥2G"}',
          '{"content":"≥16G"}',
          '{"content":"2-5T优质SSD"}',
        ],
        [
          '{"content":"3Gpbs"}',
          '{"content":"线程≥32，主频≥2G"}',
          '{"content":"≥32G"}',
          '{"content":"6-15T优质SSD"}',
        ],
      ],
      footer: '（不同运营商、区域，跑量效果不同）',
    },
    instructions: [
      {
        title: '适用设备类型',
        content: '个人电脑、服务器等x86架构设备；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型。拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不超过5%，网络延迟不超过50ms；',
      },
      {
        title: '系统推荐',
        content:
          '若整机可以共享，可以直接安装ISO镜像；非整机共享则用虚拟机方式。Win10及以上，建议用Hyper-V方式，Linux设备建议用KVM，其他情况使用VMware或Virtualbox；',
      },
      {
        title: '性能',
        content:
          'CPU、内存、磁盘性能越高越好，系统会根据配置性能来自动化部署业务，具体配置参考上图（不同网络情况，资源要求会有差别）；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步提升，收益会相对稳定；',
      },
    ],
  },
  [OEC_PRODUCT_TYPE]: {
    title: 'OEC推荐配置及说明',
    // 硬件推荐配置表格
    tableData: {
      header: ['总上行带宽', '设备数量', '每设备硬盘配置', '组网建议'],
      body: [
        [
          '{"content":"30M"}',
          '{"content":"1台"}',
          '{"content": "1块480G SSD<br />或<br />2块240G SSD"}',
          '{"content":"①NAT类型：公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型<br />②推荐使用设备拨号<br />③不同运营商、区域，资源需求不一样，配置要求会有差别，可以根据实际运行情况来调整配置","rowSpan":"3","style":{"textAlign":"justify","width":"45%"}}',
        ],
        [
          '{"content":"50M"}',
          '{"content":"1台"}',
          '{"content": "1块480G SSD<br />或<br />2块240G SSD"}',
        ],
        [
          '{"content":"100M"}',
          '{"content":"2台"}',
          '{"content": "1块480G SSD<br />或<br />2块240G SSD"}',
        ],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OEC；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [OEC_TURBO_PRODUCT_TYPE]: {
    title: 'OEC-turbo推荐配置及说明',
    // 硬件推荐配置表格
    tableData: {
      header: ['总上行带宽', '推荐设备数', '推荐硬盘大小', '组网建议'],
      body: [
        [
          '{"content":"50M"}',
          '{"content":"1"}',
          '{"content": "1T SSD<br />或<br />2块 480G SSD"}',
          '{"content":"①NAT类型：公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型<br />②推荐使用设备拨号<br />③不同运营商、区域，资源需求不一样，配置要求会有差别，可以根据实际运行情况来调整配置","rowSpan":"4","style":{"textAlign":"justify","width":"35%"}}',
        ],
        [
          '{"content":"100M"}',
          '{"content":"1台"}',
          '{"content": "1T SSD<br />或<br />2块 480G SSD"}',
        ],
        [
          '{"content":"150M"}',
          '{"content":"1台"}',
          '{"content": "1T SSD<br />或<br />2块 480G SSD"}',
        ],
        [
          '{"content":"200M"}',
          '{"content":"2台"}',
          '{"content": "每台1T SSD<br />或<br />2块 480G SSD"}',
        ],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OEC-turbo；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [OES_PRODUCT_TYPE]: {
    title: 'OES推荐配置及说明',
    tableData: {
      header: ['总上行带宽', '设备数量', '每台设备硬盘配置', '组网建议'],
      body: [
        [
          '{"content":"100M"}',
          '{"content":"1台"}',
          '{"content":"1T*1或480G*2","rowSpan":"4"}',
          '{"content":"①单线100M*1"}',
        ],
        [
          '{"content":"400"}',
          '{"content":"2台"}',
          // '{"content":"1T*1或480G*2"}',
          '{"content":"①单线200M*2<br />②单线100M*4<br />③单线50M*8&nbsp;&nbsp;<br />带宽分流成2台设备"}',
        ],
        [
          '{"content":"600M"}',
          '{"content":"2台"}',
          // '{"content":"1T*1或480G*2"}',
          '{"content":"①单线200M*3<br />②单线100M*6<br />带宽分流成2台设备"}',
        ],
        [
          '{"content":"1000M"}',
          '{"content":"3台"}',
          // '{"content":"1T*1或480G*2"}',
          '{"content":"①单线500M*2<br />②单线200M*5<br />带宽分流成3台设备"}',
        ],
      ],
      footer: '*每台设备推荐优先安装2块480G SSD，观察设备利用情况，判断是否需添加第3块480G硬盘',
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OES；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [OES_PLUS_PRODUCT_TYPE]: {
    title: 'OES Plus推荐配置及说明',
    tableData: {
      header: ['总上行带宽', '设备数量', '每台设备硬盘配置', '组网建议'],
      body: [
        [
          '{"content":"100M"}',
          '{"content":"1台"}',
          '{"content":"2-3块480G SSD"}',
          '{"content":"①单线100M*1"}',
        ],
        [
          '{"content":"400"}',
          '{"content":"2台"}',
          '{"content":"2-3块480G SSD"}',
          '{"content":"①单线200M*2<br />②单线100M*4<br />③单线50M*8&nbsp;&nbsp;<br />带宽分流成2台设备"}',
        ],
        [
          '{"content":"600M"}',
          '{"content":"2台"}',
          '{"content":"2-3块480G SSD"}',
          '{"content":"①单线200M*3<br />②单线100M*6<br />带宽分流成2台设备"}',
        ],
        [
          '{"content":"1000M"}',
          '{"content":"3台"}',
          '{"content":"2-3块480G SSD"}',
          '{"content":"①单线500M*2<br />②单线200M*5<br />带宽分流成3台设备"}',
        ],
      ],
      footer:
        ' 每台OES推荐使用 3块480G SSD，总容量不要超过1.5T；最低建议使用2块硬盘，可视缓存占用情况决定是否添加。',
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OES Plus；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [DC_PRODUCT_TYPE]: {
    title: '容器魔方推荐配置及说明',
    tableData: {
      header: ['上行带宽', 'CPU', '内存', '硬盘'],
      body: [
        [
          '{"content":"30Mbps"}',
          '{"content":"核数≥2，主频1.8G"}',
          '{"content":"≥1G"}',
          '{"content":"200G固态硬盘"}',
        ],
        [
          '{"content":"50Mbps"}',
          '{"content":"核数≥4，主频1.8G"}',
          '{"content":"≥2G"}',
          '{"content":"400G固态硬盘"}',
        ],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: '支持docker的arm32、arm64、x86_64架构的设备；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型，NAT类型越高越好；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化。',
      },
      {
        title: '性能',
        content: 'CPU、内存、磁盘性能越高越好，系统会根据配置性能来自动化部署业务。',
      },
      {
        title: '',
        content:
          '设备备激活上线需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [NAS_PRODUCT_TYPE]: {
    title: '纳思小星推荐配置及说明',
    tableData: {
      header: ['上行带宽', 'CPU', '内存', '硬盘'],
      body: [
        [
          '{"content":"10Mpbs"}',
          '{"content":"线程≥2，主频≥=1.5GHz"}',
          '{"content":"≥300M"}',
          '{"content":"≥50G HDD"}',
        ],
        [
          '{"content":"20Mpbs"}',
          '{"content":"线程≥2，主频≥=1.8GHz"}',
          '{"content":"≥500M"}',
          '{"content":"≥50G HDD"}',
        ],
      ],
      footer: '（不同运营商、区域，跑量效果不同）',
    },
    instructions: [
      {
        title: '适用设备类型',
        content: '支持安装迅雷的NAS设备；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型。拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不超过5%，网络延迟不超过50ms；',
      },
      {
        title: '性能',
        content:
          'CPU、内存、磁盘性能越高越好，系统会根据配置性能来自动化部署业务，具体配置参考上图（不同网络情况，资源要求会有差别）；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步提升，收益会相对稳定；',
      },
    ],
  },
  [PNWX_PRODUCT_TYPE]: {
    title: '手机宝推荐配置及说明',
    tableData: {
      header: ['上行带宽', '每台设备运行内存', '每台设备存储'],
      body: [
        ['{"content":"10M"}', '{"content":"4G"}', '{"content":"32G及以上"}'],
        ['{"content":"20M"}', '{"content":"4G"}', '{"content":"32G及以上"}'],
        ['{"content":"50M"}', '{"content":"6G"}', '{"content":"64G及以上"}'],
        ['{"content":"100M"}', '{"content":"12G"}', '{"content":"64G及以上"}'],
      ],
    },
    instructions: [
      {
        title: '适用设备类型',
        content: '安卓手机；',
      },
      {
        title: '配置要求',
        content: '运行内存≥3G、存储内存≥10G',
      },
      {
        title: '系统推荐',
        content: 'Andriod7.0及以上；',
      },
      {
        title: '支持的手机品牌',
        content: '华为、荣耀、小米、一加、OPPO、ViVO、魅族、三星、锤子、联想、中兴、LG、索尼、酷派',
      },
      {
        title: '性能',
        content:
          '内存、存储性能越高越好，系统会根据性能来自动化部署业务，具体配置参考上图（不同网络情况、资源要求会有差别）；',
      },
      {
        title: '网络NAT类型跑量排名',
        content: '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不建议超过5%，网络延迟不建议超过50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化；',
      },
      {
        title: '',
        content:
          '设备激活上线后需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步上升，收益会相对稳定；',
      },
    ],
  },
  [PC_PAL_PRODUCT_TYPE]: {
    title: '网心云电脑宝推荐配置及说明',
    tableData: {
      header: ['上行带宽', '每台设备运行内存', '每台设备磁盘存储'],
      body: [
        ['{"content":"10M"}', '{"content":"2G"}', '{"content":"32G及以上"}'],
        ['{"content":"20M"}', '{"content":"4G"}', '{"content":"64G及以上"}'],
        ['{"content":"50M"}', '{"content":"4G"}', '{"content":"64G及以上"}'],
        ['{"content":"100M"}', '{"content":"6G"}', '{"content":"64G及以上"}'],
      ],
    },
    instructions: [
      {
        title: '适用设备类型',
        content: 'Windows系统电脑；',
      },
      {
        title: '配置要求',
        content: '运行内存>=2G',
      },
      {
        title: '系统推荐',
        content: 'win10及以上；',
      },
      {
        title: '性能',
        content:
          '内存、存储性能越高越好，系统会根据性能来自动化部署业务，具体配置参考上图（不同网络情况、资源要求会有差别）；',
      },
      {
        title: '网络NAT类型跑量排名',
        content: '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不建议超过5%，网络延迟不建议超过50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化；',
      },
      {
        title: '',
        content:
          '设备激活上线后需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步上升，收益会相对稳定；',
      },
    ],
  },
  [XLPC_PRODUCT_TYPE]: {
    title: '迅雷PC版推荐配置及说明',
    tableData: {
      header: ['上行带宽', '每台设备运行内存', '每台设备磁盘存储'],
      body: [
        ['{"content":"10M"}', '{"content":"2G"}', '{"content":"32G及以上"}'],
        ['{"content":"20M"}', '{"content":"4G"}', '{"content":"64G及以上"}'],
        ['{"content":"50M"}', '{"content":"4G"}', '{"content":"64G及以上"}'],
        ['{"content":"100M"}', '{"content":"6G"}', '{"content":"64G及以上"}'],
      ],
    },
    instructions: [
      {
        title: '适用设备类型',
        content: 'Windows系统电脑；',
      },
      {
        title: '配置要求',
        content: '运行内存>=2G',
      },
      {
        title: '系统推荐',
        content: 'win10及以上；',
      },
      {
        title: '性能',
        content:
          '内存、存储性能越高越好，系统会根据性能来自动化部署业务，具体配置参考上图（不同网络情况、资源要求会有差别）；',
      },
      {
        title: '网络NAT类型跑量排名',
        content: '公网型＞映射公网型＞全锥型＞IP限制型＞端口限制型＞对称型',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不建议超过5%，网络延迟不建议超过50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化；',
      },
      {
        title: '',
        content:
          '设备激活上线后需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步上升，收益会相对稳定；',
      },
    ],
  },
  [OEA_PRODUCT_TYPE]: {
    title: 'OEA系列推荐配置及说明',
    tableData: {
      header: ['总上行带宽', '设备数量', '每设备硬盘配置'],
      body: [
        ['{"content":"≤50M"}', '{"content":"1"}', '{"content": "无需配置"}'],
        ['{"content":"50M-100M"}', '{"content":"2"}', '{"content": "无需配置"}'],
        ['{"content":"100M"}', '{"content":"3"}', '{"content": "无需配置"}'],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OEA系列；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [OEA_LITE_PRODUCT_TYPE]: {
    title: 'OEA系列推荐配置及说明',
    tableData: {
      header: ['总上行带宽', '设备数量', '每设备硬盘配置'],
      body: [
        ['{"content":"≤50M"}', '{"content":"1"}', '{"content": "无需配置"}'],
        ['{"content":"50M-100M"}', '{"content":"2"}', '{"content": "无需配置"}'],
        ['{"content":"100M"}', '{"content":"3"}', '{"content": "无需配置"}'],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: 'OEA系列；',
      },
      {
        title: '网络NAT类型跑量排名',
        content:
          '网络NAT类型跑量排名依次为：公网型＞映射公网型＞原始全锥型＞映射全锥型，NAT类型越高越好，其他类型暂不推荐；拨号为获取最优NAT的最佳方式，优先推荐使用PPPoE拨号以减少NAT设备优化组网，映射型公网有机会升级为卓越型公网，若使用PPPoE拨号则APP中UPNP可能显示为“关”，此为正常现象；非拨号环境，则建议设置DMZ或开启UPNP（二者选其一即可），设置DMZ时请配置MAC地址以非C0开头的设备IP；',
      },
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，建议保持丢包率越小越好，网络延迟小于50ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，查看具体是哪一个设备，根据指南进行优化，收益指标解读及优化；',
      },
      {
        title: '',
        content:
          '设备激活上线需要5-7天的缓存部署期，缓存部署完成后，贡献的流量逐步提升，收益会相对稳定。',
      },
    ],
  },
  [KOOL_PRODUCT_TYPE]: {
    title: '网心云KoolCenter版推荐配置及说明',
    tableData: {
      header: ['上行带宽', '运行内存', '磁盘存储'],
      body: [
        ['{"content":"10M"}', '{"content":"1G"}', '{"content": "30G及以上"}'],
        ['{"content":"30M"}', '{"content":"1G"}', '{"content": "60G及以上"}'],
        ['{"content":"50M"}', '{"content":"2G"}', '{"content": "80G及以上"}'],
      ],
    },
    // 说明
    instructions: [
      {
        title: '适用设备类型',
        content: '支持安装KoolCenter梅林改版固件及华硕官改固件的路由器设备；',
      },
      {
        title: '配置要求',
        content: '运行内存>=1G；',
      },
      // TODO: 内容还未提供
      {
        title: '',
        content: '请保持全天在线，限速、断电、断网将会影响收益；',
      },
      {
        title: '性能',
        content:
          'CPU、内存、存储性能越高越好，系统会根据性能来自动化部署业务，具体配置参考上图（不同网络情况、资源要求会有差别）；',
      },
      {
        title: '网络NAT类型跑量排名',
        content: '公网型>映射公网型>全锥型>IP限制型>端口限制型>对称型；',
      },
      {
        title: '',
        content: '请关注APP收益指标“丢包率”和“时延”，丢包率不建议超过5%，网络延迟不建议超过100ms；',
      },
      {
        title: '',
        content:
          '请关注APP中收益指标，建议保持指标为“优秀”。若出现收益指标“一般”或“差”的情况，可查看【设备列表-设备-历史收益指标】查看具体是哪一个设备，根据指南进行优化；',
      },
      {
        title: '',
        content:
          '设备激活上线后需要5-7天的缓存部署期，缓存部署完成后，共享的流量逐步上升，收益会相对稳定。',
      },
    ],
  },
};
